import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
import { Spinner, Dropdown } from 'react-bootstrap';

import {
    hoTroPagingAction,
    deleteHoTroAction,
    filterListHoTro
} from '@store/reducers/hotro';
import { linhVucGetAllAction } from '@store/reducers/linhvuc';
import { khoaGetAllAction } from '@store/reducers/khoa';
import { getNguoiDungByAccountId, getNguoiDungById } from '@store/reducers/nguoidung';
import { getHoTroSummaryAction, getHoTroBreakdownAction, clearThongKe } from '@store/reducers/thongke';

import { createUrlWithParam, dateTimeToStringRequest, getInfomationAccountFromToken } from '../../utils/helper'; //mới thêm phân quyên tất cả cho admin và phụ trách bộ phận
import { URI_INTERNAL } from '../../utils/pathLocations';
import { objectShowNumber, messageToast, rangeDateReport } from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { mapTrangThaiHoTroLabel, TRANG_THAI_HO_TRO_OPTIONS } from '@app/store/constants';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import * as moment from 'moment';
import Select from 'react-select';
import { Get } from '../../utils/httpProvider';
import { NGUOIDUNG_API } from '../../utils/apiUrl';
import StatisticControls from '../../components/statistic-controls/StatisticControls';
import {
    mapLoaiLoiLabel,
    mapMucDoPhucTapLabel,
    LOAI_LOI_OPTIONS,
    MUC_DO_PHUC_TAP_OPTIONS
} from '@app/store/constants';

import { userManager } from '@app/utils/oidc';



const HoTro = () => {
    const hoTroState = useSelector((state) => state.hoTro || {});
    const loadingList = !!hoTroState.loadingPaging;
    const loadingDelete = !!hoTroState.loadingDelete;


    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const valueSearch = useSelector(state => state.search.valueSearch);
    const totalHoTro = useSelector(state => state.hoTro.totalHoTro);
    const listHoTro = useSelector(state => state.hoTro.listHoTro);

    const listLinhVuc = useSelector(state => state.linhvuc.listLinhVuc || []);
    const listKhoa = useSelector(state => state.khoa.listKhoa || []);

    // cache map: nguoiDungId -> display name (hoTen)
    const [userNameMap, setUserNameMap] = useState({});

    // trạng thái loading theo từng nguoiDungId để không nháy ID
    const [loadingUserIds, setLoadingUserIds] = useState({});

    // chống gọi trùng khi listHoTro thay đổi nhanh
    const inFlightUserIdsRef = useRef(new Set());

    // nếu fetch không ra tên thì đánh dấu để không fetch lại mãi
    const notFoundUserIdsRef = useRef(new Set());


    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [accountId, setAccountId] = useState(null);
    const [myNguoiDungId, setMyNguoiDungId] = useState(null);
    const [myNguoiDungName, setMyNguoiDungName] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);     //mới thêm phân quyền tất cả cho admin và phụ trách bộ phận



    // Added filter states
    const [filterLinhVuc, setFilterLinhVuc] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [filterLoaiLoi, setFilterLoaiLoi] = useState('');
    const [filterMucDoPhucTap, setFilterMucDoPhucTap] = useState('');
    const [filterKhoa, setFilterKhoa] = useState('');
    const [filterNguoiDung, setFilterNguoiDung] = useState('');
    const [dates, setDates] = useState({ startDate: null, endDate: null });
    const [selectedNguoiDungOption, setSelectedNguoiDungOption] = useState(null);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // viewMode: 'list' | 'summary' | 'breakdown'
    const [viewMode, setViewMode] = useState('list');
    const [groupBy, setGroupBy] = useState('day');
    const [selectedUserForBreakdown, setSelectedUserForBreakdown] = useState(null);

    const thongKeState = useSelector(state => state.thongKe || {});

    // selection state for summary table
    const [selectedSummaryIds, setSelectedSummaryIds] = useState([]);
    // live search for summary table (no enter required)
    const [summarySearch, setSummarySearch] = useState('');

    // filtered summary rows according to live search
    const filteredSummary = useMemo(() => {
        const rows = Array.isArray(thongKeState.hoTroSummary) ? thongKeState.hoTroSummary : [];
        const q = (summarySearch || '').trim().toLowerCase();
        if (!q) return rows;
        return rows.filter(r => {
            const name = (r.tenNguoiDung || r.ten || r.nguoiDungName || r.nguoiDungId || '').toString().toLowerCase();
            return name.includes(q);
        });
    }, [thongKeState.hoTroSummary, summarySearch]);

    // reset selection when summary data or view changes
    useEffect(() => {
        setSelectedSummaryIds([]);
    }, [thongKeState.hoTroSummary, viewMode]);

    // toggle single selection
    const toggleSelect = (id) => {
        const key = String(id);
        setSelectedSummaryIds(prev => {
            const s = new Set(prev);
            if (s.has(key)) s.delete(key); else s.add(key);
            return Array.from(s);
        });
    };
    
    // toggle select all (current visible filtered summary rows)
    const toggleSelectAll = () => {
        const currentIds = filteredSummary.map(i => String(i.nguoiDungId || i.nguoiDung || '')).filter(Boolean);
        if (currentIds.length === 0) return;
        const allSelected = currentIds.every(id => selectedSummaryIds.includes(id));
        if (allSelected) {
            // remove currentIds from selection
            setSelectedSummaryIds(prev => (prev || []).filter(id => !currentIds.includes(id)));
        } else {
            // add currentIds to selection
            setSelectedSummaryIds(prev => Array.from(new Set([...(prev || []), ...currentIds])));
        }
    };

    // MAP FUNCTIONS
    const getTenLinhVuc = (id) => {
        const lv = listLinhVuc.find(x => x.id === id);
        return lv ? lv.name : 'Không rõ';
    };

    const getTenKhoa = (ids) => {
        if (!ids || ids.length === 0) return '';
        const names = listKhoa
            .filter(k => ids.includes(k.id))
            .map(k => k.maKhoa || k.name); // đảm bảo đúng tên
        return names.length > 0 ? names.join(', ') : 'Không rõ';
    };

    const getSoLuongHoTro = (item) => {
        // ưu tiên field BE mới trả về
        const v = item?.soLuongHoTro ?? item?.SoLuongHoTro;
        if (v !== null && v !== undefined) return Number(v) || 0;

        // fallback: tự đếm từ khoaIds trên FE
        const ids = item?.khoaIds ?? item?.KhoaIds;
        return Array.isArray(ids) ? ids.length : 0;
    };


    // options for react-select filters
    // Use string values so they match URL params (which are strings) and persist selection
    const linhVucOptions = listLinhVuc.map(lv => ({ value: String(lv.id), label: lv.name }));
    const khoaOptions = listKhoa.map(k => ({ value: String(k.id), label: k.tenKhoa || k.name || k.maKhoa }));
    const trangThaiOptions = TRANG_THAI_HO_TRO_OPTIONS.map(s => ({ value: s.value, label: s.label }));
    const loaiLoiOptions = LOAI_LOI_OPTIONS.map(s => ({ value: s.value, label: s.label }));
    const mucDoPhucTapOptions = MUC_DO_PHUC_TAP_OPTIONS.map(s => ({ value: s.value, label: s.label }));

    // compact styles for react-select to render small controls
    const selectStyles = {
        control: (provided) => ({ ...provided, minHeight: 30, height: 30, fontSize: 13 }),
        valueContainer: (provided) => ({ ...provided, padding: '0 8px' }),
        indicatorsContainer: (provided) => ({ ...provided, height: 30 }),
        input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
        option: (provided) => ({ ...provided, fontSize: 13 })
    };

    const TABLE_HEADER_FOOTER_CELL_STYLE = {
        textAlign: 'center',
        verticalAlign: 'middle'
    };

    // ==========================
    // FETCH DATA (supports filters)
    // ==========================
    const fetchData = useCallback(
        async (Page, Size, Search, Filters = {}, updateUrl = true) => {
            const model = {
                Keyword: Search,
                PageIndex: Page,
                PageSize: Size
            };

            if (Filters.linhVucId) model.LinhVucId = Filters.linhVucId;
            if (Filters.status !== undefined && Filters.status !== '') model.Status = Filters.status;
            if (Filters.loaiLoi !== undefined && Filters.loaiLoi !== '') model.LoaiLoi = Number(Filters.loaiLoi);
            if (Filters.mucDoPhucTap !== undefined && Filters.mucDoPhucTap !== '') model.MucDoPhucTap = Number(Filters.mucDoPhucTap);
            if (Filters.khoaId) model.KhoaId = Filters.khoaId;
            if (Filters.nguoiDungId) model.NguoiDungId = Filters.nguoiDungId;
            if (Filters.ngayFrom) model.NgayHoTroFrom = moment(Filters.ngayFrom).format('YYYY-MM-DD');
            if (Filters.ngayTo) model.NgayHoTroTo = moment(Filters.ngayTo).format('YYYY-MM-DD');

            await dispatch(hoTroPagingAction(model));

            // Load Lĩnh Vực + Khoa nếu chưa load
            if (listLinhVuc.length === 0) dispatch(linhVucGetAllAction());
            if (listKhoa.length === 0) dispatch(khoaGetAllAction());

            // Update URL with filters
            if (updateUrl) {
                const params = { page: Page, size: Size, search: Search };
                if (Filters.linhVucId) params.linhvuc = Filters.linhVucId;
                if (Filters.status !== undefined && Filters.status !== '') params.status = Filters.status;
                if (Filters.loaiLoi !== undefined && Filters.loaiLoi !== '') params.loaiLoi = Number(Filters.loaiLoi);
                if (Filters.mucDoPhucTap !== undefined && Filters.mucDoPhucTap !== '') params.mucDoPhucTap = Number(Filters.mucDoPhucTap);
                if (Filters.khoaId) params.khoa = Filters.khoaId;
                if (Filters.nguoiDungId) params.nguoiDung = Filters.nguoiDungId;
                // Use the same ISO strings as sent in model so backend receives consistent format
                if (model.NgayHoTroFrom) params.ngayFrom = model.NgayHoTroFrom;
                if (model.NgayHoTroTo) params.ngayTo = model.NgayHoTroTo;

                history.replace(createUrlWithParam(URI_INTERNAL.HOTRO_PATH, params));
            }
        },
        [dispatch, history, listLinhVuc.length, listKhoa.length]
    );

    // ==========================
    // QUICK SEARCH (debounce like YeuCau)
    // ==========================
    const quickSearchTimeoutRef = useRef(null);

    const buildCurrentFilters = useCallback(() => {
        return {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            loaiLoi: filterLoaiLoi,
            mucDoPhucTap: filterMucDoPhucTap,
            khoaId: filterKhoa,
            nguoiDungId: filterNguoiDung,
            ngayFrom: dates?.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates?.endDate ? dates.endDate.toDate() : null,
        };
    }, [
        filterLinhVuc,
        filterStatus,
        filterLoaiLoi,
        filterMucDoPhucTap,
        filterKhoa,
        filterNguoiDung,
        dates,
    ]);

    useEffect(() => {
        return () => {
            if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);
        };
    }, []);

    const handleQuickSearchChange = (e) => {
        const v = (e?.target?.value || '').toString();
        setSearch(v);
        setPage(1);

        if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);

        quickSearchTimeoutRef.current = setTimeout(() => {
            fetchData(1, pageSize, v, buildCurrentFilters(), true);
        }, 250);
    };

    const clearQuickSearch = () => {
        setSearch('');
        setPage(1);

        if (quickSearchTimeoutRef.current) clearTimeout(quickSearchTimeoutRef.current);

        // giữ filter hiện tại, chỉ clear keyword
        fetchData(1, pageSize, '', buildCurrentFilters(), true);
    };


    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                const user = await userManager.getUser();

                const idFromUser =
                    user?.profile?.sub ||
                    user?.profile?.accountId ||
                    user?.profile?.nameid ||
                    null;

                const nameFromUser =
                    user?.profile?.name ||
                    user?.profile?.preferred_username ||
                    user?.profile?.email ||
                    null;

                // detect admin-like roles (admin or "Phụ trách bộ phận")
                try {
                    const normalize = (s) => (s || '').toString().toLowerCase().trim();
                    let rolesArr = [];
                    const profileRoles = user?.profile?.role || user?.profile?.roles || null;
                    if (profileRoles) {
                        if (Array.isArray(profileRoles)) rolesArr = profileRoles.map(r => normalize(r));
                        else rolesArr = normalize(profileRoles).split(/[;,]/).map(r => r.trim()).filter(Boolean);
                    } else {
                        const info = getInfomationAccountFromToken();
                        const tokenRoles = info?.role || info?.roles || null;
                        if (tokenRoles) {
                            if (Array.isArray(tokenRoles)) rolesArr = tokenRoles.map(r => normalize(r));
                            else rolesArr = normalize(tokenRoles).split(/[;,]/).map(r => r.trim()).filter(Boolean);
                        }
                    }

                    const adminLike = rolesArr.includes('admin') || rolesArr.includes('manager') || rolesArr.includes('phụ trách bộ phận') || rolesArr.includes('phu trach bo phan');
                    if (mounted) setIsAdmin(Boolean(adminLike));
                } catch (e) { /* ignore role detection errors */ }

                if (mounted && idFromUser) {
                    setAccountId(String(idFromUser));
                    if (nameFromUser) setMyNguoiDungName(String(nameFromUser));

                    try {
                        const payload = await dispatch(getNguoiDungByAccountId(idFromUser)).unwrap();

                        let item = payload || null;
                        if (Array.isArray(item)) item = item[0] || null;
                        if (item && item.data) item = item.data;
                        if (Array.isArray(item)) item = item[0] || null;
                        if (item && item.data) item = item.data;

                        const foundId = item?.id || item?.nguoiDungId;
                        const foundName = item?.hoTen || item?.fullName;

                        if (mounted && foundId) setMyNguoiDungId(String(foundId));
                        if (mounted && foundName) setMyNguoiDungName(String(foundName));

                        // để bảng list hiển thị tên ngay cả khi chưa load userNameMap
                        if (mounted && foundId && foundName) {
                            setUserNameMap(prev => ({ ...prev, [String(foundId)]: foundName }));
                        }
                    } catch { }
                }
            } catch { }
        })();

        return () => { mounted = false; };
    }, [dispatch]);


    // Fetch display names for nguoiDungId present in listHoTro
    useEffect(() => {
        if (!Array.isArray(listHoTro) || listHoTro.length === 0) return;

        const ids = Array.from(
            new Set(
                listHoTro
                    .map(x => x?.nguoiDungId)
                    .filter(Boolean)
                    .map(x => String(x))
            )
        );

        // chỉ fetch các id chưa có tên, chưa in-flight, và chưa bị đánh dấu not found
        const toFetch = ids.filter(id =>
            !userNameMap[id] &&
            !inFlightUserIdsRef.current.has(id) &&
            !notFoundUserIdsRef.current.has(id)
        );

        if (toFetch.length === 0) return;

        // mark loading + in-flight
        toFetch.forEach(id => inFlightUserIdsRef.current.add(id));
        setLoadingUserIds(prev => {
            const next = { ...prev };
            toFetch.forEach(id => { next[id] = true; });
            return next;
        });

        Promise.all(
            toFetch.map(async (id) => {
                // 1) ưu tiên get by NguoiDungId
                try {
                    const res = await dispatch(getNguoiDungById(id)).unwrap();
                    let item = res || null;
                    if (Array.isArray(item)) item = item[0] || null;
                    if (item && item.data) item = item.data;
                    if (Array.isArray(item)) item = item[0] || null;

                    const name =
                        item?.hoTen || item?.fullName || item?.name || item?.ten || item?.displayName || null;

                    return { id: String(id), name };
                } catch { /* ignore */ }

                // 2) fallback get by account id (nếu API của bạn hỗ trợ)
                try {
                    const res2 = await dispatch(getNguoiDungByAccountId(id)).unwrap();
                    let item2 = res2 || null;
                    if (Array.isArray(item2)) item2 = item2[0] || null;
                    if (item2 && item2.data) item2 = item2.data;
                    if (Array.isArray(item2)) item2 = item2[0] || null;

                    const name2 =
                        item2?.hoTen || item2?.fullName || item2?.name || item2?.ten || item2?.displayName || null;

                    return { id: String(id), name: name2 };
                } catch {
                    return { id: String(id), name: null };
                }
            })
        )
            .then(results => {
                setUserNameMap(prev => {
                    const next = { ...prev };

                    results.forEach(r => {
                        const key = String(r.id);
                        if (r?.name) {
                            next[key] = r.name;          // có tên => cache
                        } else {
                            notFoundUserIdsRef.current.add(key); // không có tên => đánh dấu để khỏi fetch lại
                        }
                    });

                    return next;
                });
            })
            .finally(() => {
                setLoadingUserIds(prev => {
                    const next = { ...prev };
                    toFetch.forEach(id => { delete next[id]; });
                    return next;
                });

                toFetch.forEach(id => inFlightUserIdsRef.current.delete(id));
            });

    }, [listHoTro, dispatch, userNameMap]);


    // when parse URL has nguoiDung id, try to fetch display name and set selected option
    useEffect(() => {
        if (!filterNguoiDung) return;
        let mounted = true;
        (async () => {
            try {
                const res = await Get(NGUOIDUNG_API.GET_BY_ID(filterNguoiDung));
                const item = res && (res.data || res) || null;
                const u = Array.isArray(item) ? item[0] : item;
                if (u && mounted) {
                    const opt = { value: u.id || u.nguoiDungId || u.accountId || u.userId, label: u.hoTen || u.fullName || u.name || u.ten || u.displayName || (u.id || u.nguoiDungId) };
                    setSelectedNguoiDungOption(opt);
                }
            } catch (e) {
                // ignore
            }
        })();
        return () => { mounted = false; };
    }, [filterNguoiDung]);

    // ==========================
    // PARSE URL (including filters)
    // ==========================
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const pageParam = parseInt(params.get('page') || 1);
        const sizeParam = parseInt(params.get('size') || 20);
        const searchParam = params.get('search') || '';

        const linhvucParam = params.get('linhvuc') || '';
        const statusParam = params.get('status') || '';
        const loaiLoiParam = params.get('loaiLoi') || '';
        const mucDoPhucTapParam = params.get('mucDoPhucTap') || '';
        const khoaParam = params.get('khoa') || '';
        const nguoiDungParam = params.get('nguoiDung') || params.get('nguoihotro') || '';
        const ngayFromParam = params.get('ngayFrom') || '';
        const ngayToParam = params.get('ngayTo') || '';

        if (pageParam !== page) setPage(pageParam);
        if (sizeParam !== pageSize) setPageSize(sizeParam);
        if (searchParam !== search) setSearch(searchParam);

        setFilterLinhVuc(linhvucParam);
        setFilterStatus(statusParam);
        setFilterLoaiLoi(loaiLoiParam);
        setFilterMucDoPhucTap(mucDoPhucTapParam);
        setFilterKhoa(khoaParam);
        setFilterNguoiDung(nguoiDungParam);
        setDates({ startDate: ngayFromParam ? moment(ngayFromParam) : null, endDate: ngayToParam ? moment(ngayToParam) : null });

        fetchData(pageParam, sizeParam, searchParam, {
            linhVucId: linhvucParam,
            status: statusParam,
            loaiLoi: loaiLoiParam,
            mucDoPhucTap: mucDoPhucTapParam,
            khoaId: khoaParam,
            nguoiDungId: nguoiDungParam,
            ngayFrom: ngayFromParam ? moment(ngayFromParam).toDate() : null,
            ngayTo: ngayToParam ? moment(ngayToParam).toDate() : null
        }, false);
    }, [location.search, fetchData]);

    // ==========================
    // GLOBAL SEARCH
    // ==========================
    useEffect(() => {
        if (valueSearch && valueSearch !== search) {
            setSearch(valueSearch);
            fetchData(1, pageSize, valueSearch, {
                linhVucId: filterLinhVuc,
                status: filterStatus,
                loaiLoi: filterLoaiLoi,
                mucDoPhucTap: filterMucDoPhucTap,
                khoaId: filterKhoa,
                nguoiDungId: filterNguoiDung,
                ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
                ngayTo: dates.endDate ? dates.endDate.toDate() : null
            }, true);
            setPage(1);
        }
    }, [valueSearch, pageSize, search, fetchData]);

    // ==========================
    // PAGINATION
    // ==========================
    const changePage = (number) => {
        setPage(number);
        fetchData(number, pageSize, search, {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            loaiLoi: filterLoaiLoi,
            mucDoPhucTap: filterMucDoPhucTap,
            khoaId: filterKhoa,
            nguoiDungId: filterNguoiDung,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        fetchData(page, newSize, search, {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            loaiLoi: filterLoaiLoi,
            mucDoPhucTap: filterMucDoPhucTap,
            khoaId: filterKhoa,
            nguoiDungId: filterNguoiDung,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };

    // Apply / Reset filters
    const onApplyFilters = () => {
        const modelFilters = {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            loaiLoi: filterLoaiLoi,
            mucDoPhucTap: filterMucDoPhucTap,
            khoaId: filterKhoa,
            nguoiDungId: filterNguoiDung,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        };
        setPage(1);
        fetchData(1, pageSize, search, modelFilters, true);
    };

    const onResetFilters = () => {
        setFilterLinhVuc('');
        setFilterStatus('');
        setFilterLoaiLoi('');
        setFilterMucDoPhucTap('');
        setFilterKhoa('');
        setFilterNguoiDung('');
        setDates({ startDate: null, endDate: null });
        setPage(1);
        fetchData(1, pageSize, search, {}, true);
    };

    const onShowMine = () => {
        const myId = myNguoiDungId; // dùng ID đã map chuẩn

        if (!myId) {
            toast.warn('Chưa lấy được NguoiDungId của tài khoản đăng nhập.');
            return;
        }

        setFilterNguoiDung(String(myId));
        setSelectedNguoiDungOption({ value: String(myId), label: myNguoiDungName || 'Của tôi' });
        setSearchNguoiDung(myNguoiDungName || '');

        setPage(1);
        fetchData(1, pageSize, search, {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            loaiLoi: filterLoaiLoi,
            mucDoPhucTap: filterMucDoPhucTap,
            khoaId: filterKhoa,
            nguoiDungId: String(myId),
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };

    const onShowAll = () => {
        setFilterNguoiDung('');
        setSelectedNguoiDungOption(null);
        setSearchNguoiDung('');

        setPage(1);
        fetchData(1, pageSize, search, {
            linhVucId: filterLinhVuc,
            status: filterStatus,
            loaiLoi: filterLoaiLoi,
            mucDoPhucTap: filterMucDoPhucTap,
            khoaId: filterKhoa,
            ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
            ngayTo: dates.endDate ? dates.endDate.toDate() : null
        }, true);
    };

    const didInitMineRef = useRef(false);

    useEffect(() => {
        if (didInitMineRef.current) return;

        const sp = new URLSearchParams(location.search || '');
        const hasNguoiDungParam = sp.get('nguoiDung') || sp.get('nguoihotro');

        if (hasNguoiDungParam) {
            // URL explicit -> respect it
            didInitMineRef.current = true;
            return;
        }

        // if admin-like -> show all; else if we have mapped myNguoiDungId -> show mine
        if (isAdmin) {
            didInitMineRef.current = true;
            onShowAll();
            return;
        }

        if (myNguoiDungId) {
            didInitMineRef.current = true;
            onShowMine();
            return;
        }

        // otherwise wait until either isAdmin or myNguoiDungId becomes available
    }, [isAdmin, myNguoiDungId, location.search]);


    // ==========================
    // DELETE
    // ==========================
    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;

        try {
            // use unwrap so rejection is thrown and caught here
            await dispatch(deleteHoTroAction(idWantDelete)).unwrap();

            await dispatch(filterListHoTro(idWantDelete));
            toast.success(messageToast.messageToastDeleteSuccess);

            const newTotal = Math.max(0, (totalHoTro || 0) - 1);
            const maxPage = Math.max(1, Math.ceil(newTotal / pageSize));
            const targetPage = page > maxPage ? maxPage : page;

            if (targetPage !== page) setPage(targetPage);
            await fetchData(targetPage, pageSize, search, {
                linhVucId: filterLinhVuc,
                status: filterStatus,
                loaiLoi: filterLoaiLoi,
                mucDoPhucTap: filterMucDoPhucTap,
                khoaId: filterKhoa,
                nguoiDungId: filterNguoiDung,
                ngayFrom: dates.startDate ? dates.startDate.toDate() : null,
                ngayTo: dates.endDate ? dates.endDate.toDate() : null
            }, true);
        } catch (err) {
            const errMsg = err?.errors?.content?.[0] || err?.message || messageToast.messageToastTryCatch;
            toast.error(errMsg);
        }

        setOpenConfirmDeleteModal(false);
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };


    //copy dữ liệu
    const onCopyHoTro = (item) => {
        if (!item?.id) return;

        // đi đến trang Add + gắn copyId để HoTroAdd.js đọc và fill dữ liệu
        // kèm state để nếu muốn dùng luôn dữ liệu đang có (đỡ call API)
        history.push({
            pathname: URI_INTERNAL.HOTRO_CREATE_PATH,
            search: `?copyId=${encodeURIComponent(item.id)}`,
            state: { copyItem: item }
        });
    };


    // ==========================
    // Người hỗ trợ autocomplete (using react-select for consistent UI)
    // - fetchNguoiDungOptions(...) returns options with string values
    // - Select shows dropdown with clear (x) like other selects
    // ==========================
    const [nguoiDungOptions, setNguoiDungOptions] = useState([]);
    const [searchNguoiDung, setSearchNguoiDung] = useState('');
    const nguoiDungTimeoutRef = useRef(null);
    const allNguoiDungCacheRef = useRef([]);


    // Fetch suggestions from API and normalize nested responses
    const fetchNguoiDungOptions = async (keyword) => {
        try {
            const model = { Keyword: keyword || '', PageIndex: 1, PageSize: 20 };
            const res = await Get(NGUOIDUNG_API.GET_ALL, null, model);

            const findArray = (obj) => {
                if (!obj) return [];
                if (Array.isArray(obj)) return obj;
                if (typeof obj !== 'object') return [];
                for (const k of Object.keys(obj)) {
                    const v = obj[k];
                    if (Array.isArray(v)) return v;
                    if (v && typeof v === 'object') {
                        const nested = findArray(v);
                        if (nested && nested.length > 0) return nested;
                    }
                }
                return [];
            };

            const items = findArray(res) || [];
            const options = items.map(u => ({
                value: String(u.id || u.nguoiDungId || u.accountId || u.userId),
                label: u.hoTen || u.fullName || u.name || u.ten || u.displayName || String(u.id || u.nguoiDungId)
            }));

            allNguoiDungCacheRef.current = options;
            setNguoiDungOptions(options);
        } catch (err) {
            setNguoiDungOptions([]);
        }
    };

    const handleSelectNguoiDung = (opt) => {
        if (!opt) {
            setSelectedNguoiDungOption(null);
            setFilterNguoiDung('');
            setSearchNguoiDung('');
            return;
        }
        // opt has { value, label }
        setSelectedNguoiDungOption({ value: String(opt.value), label: opt.label });
        setFilterNguoiDung(String(opt.value));
        setSearchNguoiDung(opt.label || '');
    };

    // react-select input change (debounced)
    const handleNguoiDungSelectInputChange = (input, meta) => {
        // Chỉ xử lý khi người dùng gõ thật sự
        if (meta?.action !== 'input-change') return input;

        setSearchNguoiDung(input);

        // Nếu không có input -> ưu tiên đổ ngay từ cache (không để No options)
        if (!input) {
            if (allNguoiDungCacheRef.current.length > 0) {
                setNguoiDungOptions([...allNguoiDungCacheRef.current]); // clone để chắc chắn rerender
                return input;
            }
        }

        // Nếu có input và cache có dữ liệu -> filter local trước
        if (input && allNguoiDungCacheRef.current.length > 0) {
            const local = allNguoiDungCacheRef.current.filter(o =>
                (o.label || '').toLowerCase().includes(input.toLowerCase())
            );
            if (local.length > 0) {
                setNguoiDungOptions(local); // local là mảng mới, ok
                return input;
            }
        }

        // Debounce fetch
        if (nguoiDungTimeoutRef.current) clearTimeout(nguoiDungTimeoutRef.current);
        nguoiDungTimeoutRef.current = setTimeout(() => {
            fetchNguoiDungOptions(input || '');
        }, 250);

        return input;
    };

    const handleNguoiDungMenuOpen = () => {
        // Nếu đã cache rồi thì đổ ngay (tránh No options)
        if (allNguoiDungCacheRef.current.length > 0) {
            setNguoiDungOptions([...allNguoiDungCacheRef.current]);
            return;
        }

        // Chưa có cache -> fetch ngay danh sách (không debounce)
        fetchNguoiDungOptions('');
    };


    // ==========================
    // VIEW MODE HANDLERS
    // ==========================
    const onShowSummary = async () => {
        setViewMode('summary');
        const params = {
            from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
            to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
            linhVucId: filterLinhVuc || null,
            khoaId: filterKhoa || null
        };
        // include status filter when requesting summary (backend supports Status / Statuses)
        if (filterStatus !== undefined && filterStatus !== '') {
            params.status = Number(filterStatus);
        }
        // ask backend to include IDs in breakdown if needed later (not necessary for summary, keep default)
        await dispatch(getHoTroSummaryAction(params));
    };

    const onShowList = () => {
        setViewMode('list');
        dispatch(clearThongKe());
    };

    const onShowBreakdownForUser = async (nguoiDungId) => {
        setSelectedUserForBreakdown(nguoiDungId);
        setViewMode('breakdown');
        const params = {
            from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
            to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
            groupBy: groupBy,
            nguoiDungId: nguoiDungId
        };
        // forward status filter to breakdown as well so FE and BE consistent
        if (filterStatus !== undefined && filterStatus !== '') params.status = Number(filterStatus);
        // include ids so FE can link into specific HoTro records
        params.includeIds = true;
        params.maxIds = 50;
        await dispatch(getHoTroBreakdownAction(params));
    };

    // Navigate from breakdown row to filtered list view
    const goToFilteredList = (nguoiDungId, ngayFrom, ngayTo) => {
        const params = { nguoiDung: nguoiDungId };
        if (ngayFrom) params.ngayFrom = ngayFrom;
        if (ngayTo) params.ngayTo = ngayTo;
        history.push(createUrlWithParam(URI_INTERNAL.HOTRO_PATH, params));
        // ensure UI switches back to list so parsed query applies to list view
        setViewMode('list');
    };

    // reload breakdown when groupBy changes
    useEffect(() => {
        if (viewMode === 'breakdown' && selectedUserForBreakdown) {
            const params = {
                from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
                to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
                groupBy: groupBy,
                nguoiDungId: selectedUserForBreakdown
            };
            if (filterStatus !== undefined && filterStatus !== '') params.status = Number(filterStatus);
            params.includeIds = true;
            dispatch(getHoTroBreakdownAction(params));
        }
    }, [groupBy]);

    // date range handlers (used by DateRangePicker)
    const handleApply = (event, picker) => {
        setDates({ startDate: picker.startDate, endDate: picker.endDate });
        picker.element.val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`);
    };

    const handleCancel = (event, picker) => {
        setDates({ startDate: null, endDate: null });
        picker.element.val('');
    };

    // reload summary when groupBy changes
    useEffect(() => {
        if (viewMode === 'summary') {
            const params = {
                from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
                to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
                linhVucId: filterLinhVuc || null,
                khoaId: filterKhoa || null,
                groupBy: groupBy
            };
            dispatch(getHoTroSummaryAction(params));
        }
    }, [groupBy, viewMode]);

    // ==========================
    // RENDER
    // ==========================
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Danh sách Hỗ trợ</h3>
                        </div>

                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <form className="form-inline">
                                    <label className="mr-2">Hiển thị :</label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={onChangeShowNumber}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option key={key} value={item.value}>
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </form>

                                <div className="d-flex align-items-center">
                                    <div className="btn-group btn-group-sm mr-2">
                                        <button
                                            type="button"
                                            className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={onShowList}
                                        >
                                            Danh sách
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${viewMode === 'summary' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={onShowSummary}
                                        >
                                            Thống kê
                                        </button>
                                    </div>

                                    <NavLink
                                        className="nav-link-reject nav-link"
                                        to={URI_INTERNAL.HOTRO_CREATE_PATH}
                                    >
                                        <button type="button" className="btn btn-info btn-sm">
                                            Thêm mới
                                        </button>
                                    </NavLink>
                                </div>
                            </div>

                            {viewMode === 'list' && (
                                <>
                                    {/* Filters UI */}
                                    {/* Filters UI (giống layout YeuCau.js) */}
                                    {/* Filters UI */}
                                    <div className="mb-2">
                                        <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: 8 }}>
                                            {/* Search nằm bên trái */}
                                            <div className="input-group input-group-sm" style={{ width: 260, minWidth: 220 }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Tìm theo nội dung..."
                                                    value={search}
                                                    onChange={handleQuickSearchChange}
                                                />
                                                {search ? (
                                                    <div className="input-group-append">
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            onClick={clearQuickSearch}
                                                            title="Xóa tìm kiếm"
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>

                                            {/* Các nút nằm ngay sau search */}
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => setShowAdvancedFilters(true)}
                                                disabled={loadingList}
                                            >
                                                Lọc nâng cao
                                            </button>

                                            <button
                                                type="button"
                                                className={`btn btn-sm ${myNguoiDungId && String(filterNguoiDung) === String(myNguoiDungId)
                                                        ? 'btn-primary'
                                                        : 'btn-outline-primary'
                                                    }`}
                                                onClick={onShowMine}
                                            >
                                                Của tôi
                                            </button>

                                            <button
                                                type="button"
                                                className={`btn btn-sm ${!filterNguoiDung ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={onShowAll}
                                            >
                                                Tất cả
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-sm btn-light ml-2"
                                                title="Xóa lọc"
                                                onClick={() => { onResetFilters(); }}
                                            >
                                                Xóa lọc
                                            </button>
                                        </div>

                                        {/* MODAL LỌC NÂNG CAO (từ file cũ) */}
                                        {showAdvancedFilters && (
                                            <>
                                                {/* Backdrop để nổi modal + click ra ngoài để đóng */}
                                                <div
                                                    style={{
                                                        position: 'fixed',
                                                        inset: 0,
                                                        zIndex: 1990,
                                                        background: 'transparent'
                                                    }}
                                                    onClick={() => setShowAdvancedFilters(false)}
                                                />

                                                <div
                                                    className="modal show"
                                                    style={{
                                                        display: 'block',
                                                        position: 'fixed',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        zIndex: 2000,
                                                        width: '100%',
                                                        padding: '0 12px'
                                                    }}
                                                    tabIndex="-1"
                                                    role="dialog"
                                                    aria-modal="true"
                                                >
                                                    <div className="modal-dialog modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Lọc nâng cao</h5>
                                                                <button
                                                                    type="button"
                                                                    className="close"
                                                                    onClick={() => setShowAdvancedFilters(false)}
                                                                    aria-label="Close"
                                                                >
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>

                                                            <div className="modal-body">
                                                                <div className="container-fluid p-0">
                                                                    <div className="row">
                                                                        {/* Row 1 */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-center">
                                                                                <label
                                                                                    className="mb-0 mr-2 font-weight-bold"
                                                                                    style={{ width: 130, whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    Lĩnh vực:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={linhVucOptions}
                                                                                        value={
                                                                                            linhVucOptions.find(o => String(o.value) === String(filterLinhVuc)) || null
                                                                                        }
                                                                                        onChange={(opt) => setFilterLinhVuc(opt ? String(opt.value) : '')}
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-center">
                                                                                <label
                                                                                    className="mb-0 mr-2 font-weight-bold"
                                                                                    style={{ width: 130, whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    Trạng thái:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={trangThaiOptions.map(o => ({ ...o, value: String(o.value) }))}
                                                                                        value={
                                                                                            trangThaiOptions
                                                                                                .map(o => ({ ...o, value: String(o.value) }))
                                                                                                .find(o => String(o.value) === String(filterStatus)) || null
                                                                                        }
                                                                                        onChange={(opt) => setFilterStatus(opt ? String(opt.value) : '')}
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Row 2 */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-center">
                                                                                <label
                                                                                    className="mb-0 mr-2 font-weight-bold"
                                                                                    style={{ width: 130, whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    Loại lỗi:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={loaiLoiOptions.map(o => ({ ...o, value: String(o.value) }))}
                                                                                        value={
                                                                                            loaiLoiOptions
                                                                                                .map(o => ({ ...o, value: String(o.value) }))
                                                                                                .find(o => String(o.value) === String(filterLoaiLoi)) || null
                                                                                        }
                                                                                        onChange={(opt) => setFilterLoaiLoi(opt ? String(opt.value) : '')}
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-center">
                                                                                <label
                                                                                    className="mb-0 mr-2 font-weight-bold"
                                                                                    style={{ width: 130, whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    Mức độ phức tạp:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={mucDoPhucTapOptions.map(o => ({ ...o, value: String(o.value) }))}
                                                                                        value={
                                                                                            mucDoPhucTapOptions
                                                                                                .map(o => ({ ...o, value: String(o.value) }))
                                                                                                .find(o => String(o.value) === String(filterMucDoPhucTap)) || null
                                                                                        }
                                                                                        onChange={(opt) => setFilterMucDoPhucTap(opt ? String(opt.value) : '')}
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Row 3 */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-center">
                                                                                <label
                                                                                    className="mb-0 mr-2 font-weight-bold"
                                                                                    style={{ width: 130, whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    Khoa:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={khoaOptions}
                                                                                        value={
                                                                                            khoaOptions.find(o => String(o.value) === String(filterKhoa)) || null
                                                                                        }
                                                                                        onChange={(opt) => setFilterKhoa(opt ? String(opt.value) : '')}
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-center">
                                                                                <label
                                                                                    className="mb-0 mr-2 font-weight-bold"
                                                                                    style={{ width: 130, whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    Người hỗ trợ:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <Select
                                                                                        styles={selectStyles}
                                                                                        options={nguoiDungOptions}
                                                                                        value={
                                                                                            selectedNguoiDungOption
                                                                                                ? { value: String(selectedNguoiDungOption.value), label: selectedNguoiDungOption.label }
                                                                                                : null
                                                                                        }
                                                                                        onChange={handleSelectNguoiDung}
                                                                                        onInputChange={handleNguoiDungSelectInputChange}
                                                                                        onMenuOpen={handleNguoiDungMenuOpen}
                                                                                        isClearable
                                                                                        placeholder="Tất cả"
                                                                                        classNamePrefix="react-select-sm"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Row 4 */}
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="d-flex align-items-center">
                                                                                <label
                                                                                    className="mb-0 mr-2 font-weight-bold"
                                                                                    style={{ width: 130, whiteSpace: 'nowrap' }}
                                                                                >
                                                                                    Thời gian:
                                                                                </label>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <DateRangePicker
                                                                                        onApply={handleApply}
                                                                                        onCancel={handleCancel}
                                                                                        initialSettings={{
                                                                                            autoUpdateInput: false,
                                                                                            locale: { format: 'DD/MM/YYYY', cancelLabel: 'Xóa', applyLabel: 'Chọn' },
                                                                                            linkedCalendars: false,
                                                                                            showDropdowns: true
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control form-control-sm"
                                                                                            style={{ width: '100%' }}
                                                                                            value={
                                                                                                dates.startDate && dates.endDate
                                                                                                    ? `${dates.startDate.format('DD/MM/YYYY')} - ${dates.endDate.format('DD/MM/YYYY')}`
                                                                                                    : ''
                                                                                            }
                                                                                            onChange={(e) => {
                                                                                                if (!e.target.value) setDates({ startDate: null, endDate: null });
                                                                                            }}
                                                                                        />
                                                                                    </DateRangePicker>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="modal-footer">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm mr-2"
                                                                    onClick={() => { onApplyFilters(); setShowAdvancedFilters(false); }}
                                                                >
                                                                    Áp dụng
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm"
                                                                    onClick={() => { onResetFilters(); setShowAdvancedFilters(false); }}
                                                                >
                                                                    Xóa lọc
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-light btn-sm"
                                                                    onClick={() => setShowAdvancedFilters(false)}
                                                                >
                                                                    Đóng
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>


                                    <div style={{ position: 'relative' }}>
                                        {(loadingList || loadingDelete) && (
                                            <div
                                                className="d-flex flex-column justify-content-center align-items-center"
                                                style={{
                                                    position: 'absolute',
                                                    inset: 0,
                                                    background: 'rgba(255,255,255,0.65)',
                                                    zIndex: 5,
                                                }}
                                            >
                                                <Spinner animation="border" />
                                                {/*<div className="mt-2 text-muted"></div>*/}
                                            </div>
                                        )}
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>STT</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người hỗ trợ</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Lĩnh vực</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày hỗ trợ</th>
                                                <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: '35%' }}>Nội dung</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                                                <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: '10%' }}>Khoa hỗ trợ</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Số lượng</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Loại lỗi</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Mức độ phức tạp</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ghi chú</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Chức năng</th>
                                            </tr>
                                        </thead>

                                        {listHoTro && listHoTro.length > 0 ? (
                                            <tbody>
                                                {listHoTro.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1 + (page - 1) * pageSize}</td>
                                                        <td>
                                                            {(() => {
                                                                const id = item?.nguoiDungId ? String(item.nguoiDungId) : '';
                                                                const name = id ? userNameMap[id] : '';

                                                                if (name) return <span>{name}</span>;
                                                                if (id && loadingUserIds[id]) return <span className="text-muted">Đang tải...</span>;

                                                                // không lộ ID nữa
                                                                return <span className="text-muted">—</span>;
                                                            })()}

                                                            {/* giữ hidden id nếu bạn cần dùng cho debug/logic khác */}
                                                            <span className="d-none" data-nguoidungid={item.nguoiDungId}>{item.nguoiDungId}</span>
                                                        </td>

                                                        <td>{getTenLinhVuc(item.linhVucId)}</td>
                                                        <td>{item.ngayHoTro ? new Date(item.ngayHoTro).toLocaleDateString() : ''}</td>
                                                        <td style={{ width: '35%', whiteSpace: 'pre-wrap', wordBreak: 'break-word', }} >{item.noiDung}</td>
                                                        <td>{mapTrangThaiHoTroLabel(item.status)}</td>
                                                        <td style={{ width: '10%' }}>{getTenKhoa(item.khoaIds)}</td>
                                                        <td>{getSoLuongHoTro(item)}</td>
                                                        <td>{mapLoaiLoiLabel(item.loaiLoi)}</td>
                                                        <td>{mapMucDoPhucTapLabel(item.mucDoPhucTap)}</td>
                                                        <td>{item.ghiChu}</td>
                                                        <td>
                                                            <Dropdown align="end">
                                                                <Dropdown.Toggle
                                                                    variant="outline-secondary"
                                                                    size="sm"
                                                                    id={`hotro-actions-${item.id}`}
                                                                >
                                                                    Thao tác
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {/* Sửa */}
                                                                    <Dropdown.Item
                                                                        as={NavLink}
                                                                        to={createUrlWithParam(URI_INTERNAL.HOTRO_EDIT_PATH, { id: item.id })}
                                                                        exact
                                                                    >
                                                                        <i className="fas fa-pen mr-2" />
                                                                        Sửa
                                                                    </Dropdown.Item>

                                                                    {/* Xóa */}
                                                                    <Dropdown.Item
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            deleteAction(item.id, item.noiDung);
                                                                        }}
                                                                    >
                                                                        <i className="far fa-trash-alt mr-2" />
                                                                        Xóa
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Divider />

                                                                    {/* Tạo bản sao */}
                                                                    <Dropdown.Item
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            onCopyHoTro(item);
                                                                        }}
                                                                    >
                                                                        <i className="far fa-copy mr-2" />
                                                                        Tạo bản sao
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        ) : (
                                            <tbody>
                                                <tr className="txt-center">
                                                    <td colSpan="12">Không có dữ liệu</td>
                                                </tr>
                                            </tbody>
                                        )}

                                        <tfoot>
                                            <tr>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>STT</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Người hỗ trợ</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Lĩnh vực</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ngày hỗ trợ</th>
                                                <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: '35%' }}>Nội dung</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Trạng thái</th>
                                                <th style={{ ...TABLE_HEADER_FOOTER_CELL_STYLE, width: '10%' }}>Khoa hỗ trợ</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Số lượng</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Loại lỗi</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Mức độ phức tạp</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Ghi chú</th>
                                                <th style={TABLE_HEADER_FOOTER_CELL_STYLE}>Chức năng</th>
                                            </tr>
                                        </tfoot>

                                        </Table>
                                    </div>

                                    <div className="dataTables_paginate paging_simple_numbers">
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            innerClass={"pagination pagination-sm no-margin pull-right"}
                                            activePage={page}
                                            itemsCountPerPage={Number(pageSize)}
                                            totalItemsCount={totalHoTro}
                                            pageRangeDisplayed={5}
                                            onChange={changePage}
                                        />
                                    </div>
                                </>
                            )}

                            {viewMode === 'summary' && (
                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <StatisticControls
                                            dates={dates}
                                            setDates={setDates}
                                            groupBy={groupBy}
                                            setGroupBy={setGroupBy}
                                            onReload={onShowSummary}
                                            onBack={onShowList}
                                            ranges={rangeDateReport}
                                        />
                                    </div>

                                    {thongKeState.loading ? (
                                        <div className="text-center my-3"><Spinner animation="border" /></div>
                                    ) : Array.isArray(thongKeState.hoTroSummary) && thongKeState.hoTroSummary.length > 0 ? (
                                        <>
                                            <div className="mb-2">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Tìm người hỗ trợ..."
                                                    value={summarySearch}
                                                    onChange={(e) => setSummarySearch(e.target.value)}
                                                    style={{ maxWidth: 320 }}
                                                />
                                            </div>

                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: 30 }}>
                                                            <input
                                                                type="checkbox"
                                                                onChange={toggleSelectAll}
                                                                checked={filteredSummary.length > 0 && filteredSummary.every(i => selectedSummaryIds.includes(String(i.nguoiDungId || i.nguoiDung || '')))}
                                                            />
                                                        </th>
                                                        <th>STT</th>
                                                        <th>Người hỗ trợ</th>
                                                        <th>Hoàn thành</th>
                                                        <th>Đang thực hiện</th>
                                                        <th>Tổng</th>
                                                        <th>Chi tiết</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {filteredSummary.map((item, index) => {
                                                        const idKey = String(item.nguoiDungId || item.nguoiDung || '');
                                                        const completed = item.completedCount ?? item.CompletedCount ?? 0;
                                                        const inProgress = item.inProgressCount ?? item.InProgressCount ?? 0;
                                                        const total = item.total ?? item.Total ?? item.count ?? item.Count ?? (completed + inProgress);
                                                        const checked = selectedSummaryIds.includes(idKey);
                                                        return (
                                                            <tr key={idKey || index}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={checked}
                                                                        onChange={() => toggleSelect(idKey)}
                                                                    />
                                                                </td>
                                                                <td>{index + 1}</td>
                                                                <td>{item.tenNguoiDung || item.ten || item.nguoiDungName || item.nguoiDungId}</td>
                                                                <td className="text-center">{completed}</td>
                                                                <td className="text-center">{inProgress}</td>
                                                                <td className="text-center">{total}</td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-info"
                                                                        onClick={() => onShowBreakdownForUser(item.nguoiDungId || item.nguoiDung)}
                                                                    >
                                                                        Xem chi tiết
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>

                                                {selectedSummaryIds && selectedSummaryIds.length > 0 && (() => {
                                                    const setSel = new Set(selectedSummaryIds);
                                                    const rows = (thongKeState.hoTroSummary || []).filter(r => setSel.has(String(r.nguoiDungId || r.nguoiDung || '')));
                                                    const sumCompleted = rows.reduce((s, r) => s + (r.completedCount ?? r.CompletedCount ?? 0), 0);
                                                    const sumInProgress = rows.reduce((s, r) => s + (r.inProgressCount ?? r.InProgressCount ?? 0), 0);
                                                    const sumTotal = rows.reduce((s, r) => s + (r.total ?? r.Total ?? r.count ?? r.Count ?? ((r.completedCount ?? r.CompletedCount ?? 0) + (r.inProgressCount ?? r.InProgressCount ?? 0))), 0);
                                                    return (
                                                        <tfoot>
                                                            <tr className="font-weight-bold">
                                                                <td />
                                                                <td colSpan={2}>Tổng chọn</td>
                                                                <td className="text-center">{sumCompleted}</td>
                                                                <td className="text-center">{sumInProgress}</td>
                                                                <td className="text-center">{sumTotal}</td>
                                                                <td />
                                                            </tr>
                                                        </tfoot>
                                                    );
                                                })()}
                                            </Table>

                                            <div className="text-center my-3">
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass={"pagination pagination-sm no-margin pull-right"}
                                                    activePage={page}
                                                    itemsCountPerPage={Number(pageSize)}
                                                    totalItemsCount={totalHoTro}
                                                    pageRangeDisplayed={5}
                                                    onChange={changePage}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center text-muted">Không có dữ liệu thống kê.</div>
                                    )}
                                </div>
                            )}

                            {viewMode === 'breakdown' && (
                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <button className="btn btn-sm btn-secondary mr-2" onClick={onShowSummary}>Quay lại thống kê</button>
                                            {/*<strong>Group by: {groupBy}</strong>*/}
                                        </div>
                                        <div>
                                            <button className="btn btn-sm btn-primary" onClick={() => dispatch(getHoTroBreakdownAction({
                                                from: dates.startDate ? dates.startDate.format('YYYY-MM-DD') : null,
                                                to: dates.endDate ? dates.endDate.format('YYYY-MM-DD') : null,
                                                groupBy: groupBy,
                                                nguoiDungId: selectedUserForBreakdown
                                            }))}>Tải lại</button>
                                        </div>
                                    </div>

                                    {thongKeState.loading ? (
                                        <div className="text-center my-3"><Spinner animation="border" /></div>
                                    ) : Array.isArray(thongKeState.hoTroBreakdown) && thongKeState.hoTroBreakdown.length > 0 ? (
                                        <>
                                            {/* show totals for selected user */}
                                            {(() => {
                                                const rows = thongKeState.hoTroBreakdown;
                                                const totalCompleted = rows.reduce((s, r) => s + (r.completedCount ?? r.CompletedCount ?? 0), 0);
                                                const totalInProgress = rows.reduce((s, r) => s + (r.inProgressCount ?? r.InProgressCount ?? 0), 0);
                                                const grandTotal = rows.reduce((s, r) => s + (r.total ?? r.Total ?? r.count ?? r.Count ?? ((r.completedCount ?? r.CompletedCount ?? 0) + (r.inProgressCount ?? r.InProgressCount ?? 0))), 0);
                                                return (
                                                    <div className="mb-2 small text-muted">Tổng: Hoàn thành: <strong>{totalCompleted}</strong> — Đang thực hiện: <strong>{totalInProgress}</strong> — Tổng: <strong>{grandTotal}</strong></div>
                                                );
                                            })()}

                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th>STT</th>
                                                        <th>Thời gian</th>
                                                        <th>Hoàn thành</th>
                                                        <th>Đang thực hiện</th>
                                                        <th>Tổng</th>
                                                        <th>Hành động</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {thongKeState.hoTroBreakdown.map((item, index) => {
                                                        const raw = item.period || item.date || item.key || '';
                                                        let display = raw;
                                                        try {
                                                            if (raw && (moment(raw, moment.ISO_8601, true).isValid() || /^\d{4}-\d{2}-\d{2}/.test(raw))) {
                                                                display = moment(raw).format('DD/MM/YYYY');
                                                            }
                                                        } catch (e) { /* ignore */ }

                                                        const completed = item.completedCount ?? item.CompletedCount ?? 0;
                                                        const inProgress = item.inProgressCount ?? item.InProgressCount ?? 0;
                                                        const total = item.total ?? item.Total ?? item.count ?? item.Count ?? (completed + inProgress);
                                                        const ids = item.hoTroIds ?? item.HoTroIds ?? null;

                                                        return (
                                                            <tr key={`${raw}-${index}`}>
                                                                <td>{index + 1}</td>
                                                                <td>{display}</td>
                                                                <td>{completed}</td>
                                                                <td>{inProgress}</td>
                                                                <td>{total}</td>
                                                                <td>
                                                                    {Array.isArray(ids) && ids.length > 0 ? (
                                                                        <>
                                                                            <button className="btn btn-sm btn-link" onClick={() => history.push(createUrlWithParam(URI_INTERNAL.HOTRO_EDIT_PATH, { id: ids[0] }))}>Mở</button>
                                                                            <span className="small text-muted"> ({ids.length})</span>
                                                                        </>
                                                                    ) : (
                                                                        <button className="btn btn-sm btn-outline-primary" onClick={() => goToFilteredList(selectedUserForBreakdown, item.period, item.period)}>Xem</button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </>
                                    ) : (
                                        <div className="text-center text-muted">Không có dữ liệu chi tiết.</div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={acceptDelete}
                handleCancel={cancelDelete}
                content={confirmDelMessage}
            />
        </div>
    );
};

export default HoTro;
